// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-5a38507b]{border:none;border-radius:8px;color:#fff;padding:6px 12px;background:#c91919}button.secondary[data-v-5a38507b]{background:#939393}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
